import React from 'react';
import { Base } from 'src/components/index';
import GoalsActions from 'src/containers/Goals/GoalsActions';
import GoalsList from 'src/containers/Goals/GoalsList';
import GoalsStatistics from 'src/containers/Goals/GoalsStatistics';
import TopFilters from 'src/containers/Goals/TopFilters';
import HeaderV2 from 'src/containers/Header/HeaderV2';
import STYLE from 'src/constants/style';

const Goals = () => (
  <>
    <HeaderV2 overtitle='Tracking' title='Goals' />
    <GoalsActions />
    <Base className={STYLE.BASE}>
      <TopFilters
        showActions={false}
        classes='flex-wrap mini:flex-nowrap'
        selectClasses='w-32 mini:w-36 desktop:w-44 full:w-48 wide:w-60'
      />
      <GoalsStatistics />
      <GoalsList />
    </Base>
  </>
);

export default Goals;
